module.exports = __webpack_public_path__ + "static/media/slide3_article1_small.47dea18e.jpg";